// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"magazines_3wTq5","wrapper__thumbnail":"magazines_3n6Cr","wrapper__thumbnail__active":"magazines_2rLXq","wrapper__thumbnail__block":"magazines_3UYjW","wrapper__thumbnail__elements":"magazines_2USiV","wrapper__index":"magazines_2o6_W","wrapper__popover":"magazines_b0NbZ","wrapper__popover__right":"magazines_2B-at","wrapper__popover__left":"magazines_1V1YL","wrapper__popover__top":"magazines_39K6P","wrapper__popover__bottom":"magazines_1EU7E"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Thumbnail/styles.scss
// module id = 1262
// module chunks = 1